<template>
  <MathAccordion :title="title">
    <p class="p-3">($ = {{ currencyExchangeRate }} р.)</p>
    <p v-for="(val, key) in arResult" :key="key" class="text-2xl mb-3">
      <span>
        {{ val.data.operands[0] }}&#36;
      </span>
      =
      <span @click="changeVisible(key)" class="res">
        _
        <strong :class="arResult[key].resShow ? 'show' : 'hide'">
          {{ val.data.res }}
        </strong>
      </span>
    </p>
    <template #actions>
      <button
        type="button"
        class="px-4 py-2 text-sm font-medium text-blue-700 border border-blue-300 rounded hover:bg-blue-50 transition"
        @click="reloadTasks"
      >
        Перегенерировать
      </button>
    </template>
  </MathAccordion>
</template>

<script>
import MathAccordion from "@/Components/Math/MathAccordion.vue";
import { generateConversionTasks } from "@/lib/mathTasks";

export default {
  name: "AppConversion",
  components: {
    MathAccordion,
  },
  props: {
    arParams: Object,
  },
  data() {
    return {
      arResult: [],
      currencyExchangeRate: 75,
      title: this.arParams.title,
    };
  },
  mounted() {
    this.reloadTasks();
  },
  methods: {
    changeVisible(key) {
      this.arResult[key].resShow = true;
    },
    reloadTasks() {
      this.arResult = generateConversionTasks(this.arParams, this.currencyExchangeRate);
    },
  },
};
</script>
